import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as S from "@styled";
import CustomModal from "shared/components/CustomModal";
import { State } from 'processEditor/model/State';
import { closeDependencyConstraintConfirmationModal } from 'processEditor/actions/SaveProcess';


export const DependencyConstraintsConfirmationModal: React.FC = () => {
    const dependencyConstraintsErrorMessage = useSelector<State, string | null | undefined>((state) => state.uiState.dependencyConstraintsErrorMessage)
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(closeDependencyConstraintConfirmationModal({ignoreWarning: false}));
    }

    const handleIgnoreWarning = () => {
        dispatch(closeDependencyConstraintConfirmationModal({ignoreWarning: true}));
    }

    return (
        <CustomModal
            label="confirm-save"
            size='small'
            onClose={handleClose}
            show={true}
            shouldCloseOnOverlayClick={true}
        >
            <S.WarningContainer>
                <div className="alert alert-warning">
                    <p className="alert-label">
                        <b>Package dependency constraint warning</b>
                        <br /><br />
                        <pre style={{ whiteSpace: "pre-wrap" }}>{dependencyConstraintsErrorMessage}</pre>
                        <p>Ignoring this warning allows you to save the Process but may lead to runtime errors.</p>
                    </p>
                </div>
              
            </S.WarningContainer>


            <S.ButtonGroup gap={12} $justifyContentEnd={true}>
                <S.Button id="close-modal-button" variant={S.ButtonType.bordered} onClick={handleClose}>{FRENDS.Localizations.Close}</S.Button>
                <S.Button id="import-bpmn-button" onClick={handleIgnoreWarning}>Ignore warning</S.Button>
            </S.ButtonGroup>
        </CustomModal>
    );
}


